import { Alert, Skeleton } from '@mui/material';
import { AsyncRenderer } from '@client/new/components/AsyncRenderer/AsyncRenderer';
import { PercentInput } from '@client/new/components/PercentInput/PercentInput';
import { Typography } from '@design-system/components/typography/typography';
import { Button } from '@design-system/components/button/button';

import { useOtpOfferFee } from './useOtpOfferFee';

type OtpSplitProps = {
  influencerId: number;
};

export const OtpOfferRevenue = (p: OtpSplitProps) => {
  const otpModel = useOtpOfferFee({ influencerId: p.influencerId });

  return (
    <AsyncRenderer
      data={otpModel}
      loadRender={
        <>
          <Skeleton
            variant="rectangular"
            sx={{ width: '100%', height: 30, marginBottom: '10px' }}
          />
          <Skeleton variant="rectangular" sx={{ width: '100%', height: 30 }} />
        </>
      }
      renderer={(p) => (
        <div>
          <div className="flex justify-between">
            <div className="flex flex-col">
              <Typography variant="headline" size="small" className="pb-[20px]">
                OTP Offers Revenue
              </Typography>
            </div>
            <div className="flex flex-end gap-2.5">
              {p.cta.map((item) => (
                <Button color="neutral" key={item.label} onClick={item.onClick}>
                  {item.label}
                </Button>
              ))}
            </div>
          </div>
          <div className="flex flex-col">
            <Typography className="pb-1" variant="body" size="medium">
              Default Playbook Fee (%)
            </Typography>
            <PercentInput
              value={p.fee}
              onChange={p.onChange}
              disabled={p.disabled}
            />
            <Alert
              severity="info"
              sx={{
                marginTop: '30px',
                backgroundColor: 'rgb(194, 210, 236, 0.6)',
                color: 'black',
                fontFamily: 'Visuelt',
              }}
            >
              If you wish to modify the payout ratio for a specific OTP offer,
              please navigate to the offer's settings.
            </Alert>
          </div>
        </div>
      )}
    />
  );
};
